var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableWithPagination',{attrs:{"tableData":_vm.targetLists,"max-height":"400px","columnList":_vm.columnList}})}
var staticRenderFns = []

export { render, staticRenderFns }